import ImageItem from './imageItem';
import withMagnified from '../hoc/withMagnified';
export default withMagnified(ImageItem);
//# sourceMappingURL=imageWithMagnified.js.map